import {ReactElement, useCallback, useEffect, useState} from "react";
import {styled} from "styled-components";

import {getFournisseurTableauBord as fetchFournisseur} from "@/Api/fournisseur";
import {ErrorBoundary} from "@/components/ErrorBoundary/ErrorBoundary";
import {FournisseurUserTableauBord} from "@/components/Fournisseur/FournisseurContent/FournisseurUserTableauBord";
import {LoadingOrError} from "@/components/LoadingOrError/LoadingOrError";
import {AppContext} from "@/context/AppContext";
import {HookFormContextProvider} from "@/context/HookFormContext";
import {
  UserParamContext,
  UserParamContextType,
} from "@/context/UserParamContext";
import {useGetContext} from "@/hooks/useGetContext/useGetContext";
import {useIsConnectedTest} from "@/hooks/useIsConnectedTest/useIsConnectedTest";
import {useLoadingState} from "@/hooks/useLoadingState/useLoadingState";
import {AppContext as AppContextType} from "@/ts/appContext";
import {FournisseurUserTableauBord as FournisseurUserTableauBordType} from "@/ts/fournisseur";

const FournisseurContent = styled.div`
  width: 100%;
  display: grid;
  gap: 40px;
`;

export function FournisseurTableauDeBord(): ReactElement | null {
  // Vérifie si l'utilisateur est connecté et redirige vers la page de connexion si ce n'est pas le cas
  const isAuthorized = useIsConnectedTest();

  const {API} = useGetContext<AppContextType>(AppContext, "AppContext");
  const {currentCampagne} = useGetContext<UserParamContextType>(
    UserParamContext,
    "UserParamContext"
  );
  const loadingState = useLoadingState();
  const [fournisseurDashboard, setFournisseurDashboard] = useState<
    FournisseurUserTableauBordType | undefined
  >(undefined);
  const getFournisseurDashboard = useCallback(async (): Promise<void> => {
    // if (currentCampagne?.value) {
    const reponse =
      await loadingState.executeWithLoading<FournisseurUserTableauBordType>(
        () => fetchFournisseur(API, currentCampagne?.value || undefined)
      );
    setFournisseurDashboard(reponse);
    // } else {
    //   loadingState.setError("Aucune campagne n'a été sélectionnée");
    // }
  }, [loadingState, API]);
  useEffect(() => {
    getFournisseurDashboard();
  }, [currentCampagne]);

  // si l'utilisateur n'est pas connecté, on ne rend pas la page
  if (!isAuthorized) {
    return null;
  }

  return (
    <ErrorBoundary
      fallbackText="Erreur lors de la récupération du tableau de bord du fournisseur"
      buttonToRefresh={true}>
      <FournisseurContent data-testid="FournisseurContent">
        <HookFormContextProvider>
          <LoadingOrError
            loadingState={loadingState}
            errorImage="/path/to/error-image.png"
            buttonToRefresh={true}
            onRetry={async () => await getFournisseurDashboard()}
            data={fournisseurDashboard}
            dataValidator={data => data && data?.fournisseur}>
            {fournisseurDashboard && (
              <FournisseurUserTableauBord
                fournisseur={fournisseurDashboard!.fournisseur}
                campagne={fournisseurDashboard!.campagne}
                bonus={fournisseurDashboard!.bonus}
                notifications={fournisseurDashboard!.notifications}
                adherents={fournisseurDashboard!.adherents_avec_contrat?.filter(
                  adherent =>
                    adherent.contrat_statut === "actif" ||
                    adherent.contrat_statut === "cloture"
                )}
              />
            )}
          </LoadingOrError>
        </HookFormContextProvider>
      </FournisseurContent>
    </ErrorBoundary>
  );
}
